
$(document).ready(function(){

  $('.select_color_label').empty();
  var currenct_value = $('.variant_options input[type=radio]:checked').next('label').attr('data-option-name');
    $('.select_color_label').attr('current-data',currenct_value);
  var currenct_variant = $('.drop_down_color_label ul li[data-variant="'+currenct_value+'"]').html();
  $('.select_color_label').append(currenct_variant);
  
  $('.select_color_label').click(function(e){
  
      $(this).parents('.drop_down_color_label').toggleClass('active');

       e.stopPropagation()
  });


  $('.drop_down_color_label ul li').click(function(e){
  $('.select_color_label').empty();
    $('.drop_down_color_label').removeClass('active');
      var selected_value = $(this).attr('data-variant');

    $('.select_color_label').attr('current-data',selected_value);
    
    $('.select_color_label').append($(this).html());

      $('.color_picker[data-option-name="'+selected_value+'"').trigger('click');
        
      e.stopPropagation()
  });
  
$(document).click(function (e) {
    if (! $(e.target).hasClass('active'))
    {
      $(".drop_down_color_label").removeClass('active');
    }
  
});

});